import React, { useContext } from "react";
import {
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataContext } from "./index";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import ComponentBackdrop from "../../components/backdrop";
import { Visibility } from "@mui/icons-material";
import CustomToolbar from "../../utils/customToolbar";
import { DataGrid } from "@mui/x-data-grid";

export default function Listing({ handleShowButton }) {

  const rows = useContext(DataContext);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === 'include') {
      selectedIds = Array.from(id.ids);
    }
    else if (id.type === 'exclude') {
      const excluded = new Set(id.ids);
      selectedIds = rows.filter(row => !excluded.has(row.id)).map(row => row.id);
    }
    handleShowButton(selectedIds);
  }

  const navigateDetails = (id) => {
    navigate(`/view-campaign/${id}`);
  }

  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)}
        >
          <Tooltip title="View" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,
      ],
    },
    {
      field: "rewardId",
      headerName: "#",
      width: 80,
      align: "center",
    },
    {
      field: "name",
      headerName: "Campaign Title",
      width: 200,
      align: "left",
    },
    {
      field: "description",
      headerName: "Description",
      width: 150,
      align: "left",
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 150,
      valueGetter: (params) => {
        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 150,
      valueGetter: (params) => {
        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
    {
      field: "qty",
      headerName: "Quantity",
      minWidth: 100,
      align: "center",
    },
    {
      field: "entitlementPoint",
      headerName: "Entitlement Point",
      minWidth: 100,
      align: "center",
    },
    // {
    //   field: "mainImg",
    //   headerName: "Main Image",
    //   width: 200,
    //   headerAlign: "center",
    //   align: "center",
    //   renderCell: (params) => {
    //     if (!params.value) {
    //       return <Box sx={{ color: 'text.secondary' }}>No Image</Box>;
    //     }
    //     return (
    //       <Box
    //         component="img"
    //         src={params.value}
    //         alt="Event"
    //         sx={{
    //           width: '100%',
    //           maxHeight: 100,
    //           objectFit: 'cover',
    //           borderRadius: 1,
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      align: "center",
      valueGetter: (params) => {
        const value = params;
        if (value === "InProgress") return "In Progress";
        return value; 
      },
    },
    //uncomment after team field is added to the json
    // {
    //   field: "teamId",
    //   headerName: "Team",
    //   minWidth: 200,
    // },
    {
      field: "createdBy",
      headerName: "Created By",
      width: 150,
      align: "center",
    },
    {
      field: "createddate",
      headerName: "Created Date",
      minWidth: 150,
      valueGetter: (params) => {

        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
  ];

  return (
    <div>
        <Box
          style={{
            width: "100%",
            height: "77vh",
            overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
          }}
        >
        <ComponentBackdrop open={open} close={handleClose} />
        <DataGrid
          columns={columns}
          rows={rows}
          showToolbar
          slots={{ 
            toolbar: CustomToolbar,
          }}
          pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 50 },
            },
            sorting: {
              sortModel: [{ field: 'rewardId', sort: 'desc' }],
            },
            columns: {
              columnVisibilityModel: {
                rewardId: false,
                createddate: false,
                createdBy:false
              },
            },
             filter: {
              filterModel: {
                items: [
                  {
                    field: "status",
                    operator: "doesNotEqual",
                    value: "Cancelled", // ✅ default filter
                  },
                ],
              },
            },
          }}
          onRowSelectionModelChange={(id) => {
            onSelectedCheckbox(id, rows);
          }
          }
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={{ 
            noRowsLabel: "No records found",
          }}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true"
            },
            toolbar: {
              title: "",
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true }
            },
          }}
        />
      </Box>
    </div>
  );
}
